enum WorkOrderType {
  None = "None",
  Service = "Service",
  PreventativeMaintenance = "PreventativeMaintenance",
  Survey = "Survey",
}

export default WorkOrderType;
